import { AlertsPage } from './view';

export function AlertsModule() {
  return <AlertsPage />;
}
